import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const InfoOutlineSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "6.8 7 66.9 66.9",
  color = "#236998",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <path
        d="M40.3188 73.6667C58.5556 73.6667 73.6667 58.578 73.6667 40.3333C73.6667 22.0886 58.5266 7 40.2898 7C22.069 7 7 22.0886 7 40.3333C7 58.578 22.098 73.6667 40.3188 73.6667ZM40.3188 68.7575C24.5936 68.7575 11.9521 56.0944 11.9521 40.3333C11.9521 24.5722 24.5646 11.9092 40.2898 11.9092C56.044 11.9092 68.7306 24.5722 68.7306 40.3333C68.7306 56.0944 56.0731 68.7575 40.3188 68.7575ZM34.4969 58.6622H47.9511C49.1525 58.6622 50.0984 57.7899 50.0984 56.572C50.0984 55.4253 49.1525 54.5109 47.9511 54.5109H43.5325V36.8549C43.5325 35.3017 42.7316 34.2711 41.269 34.2711H34.9714C33.77 34.2711 32.8531 35.1856 32.8531 36.3163C32.8531 37.521 33.77 38.4065 34.9714 38.4065H38.9156V54.5109H34.4969C33.2825 54.5109 32.3496 55.4253 32.3496 56.572C32.3496 57.7899 33.2825 58.6622 34.4969 58.6622ZM40.0866 28.4951C42.2933 28.4951 44.0414 26.7563 44.0414 24.5487C44.0414 22.341 42.2933 20.5922 40.0866 20.5922C37.909 20.5922 36.1319 22.341 36.1319 24.5487C36.1319 26.7563 37.909 28.4951 40.0866 28.4951Z"
        fill={color}
      />
    </svg>
  );
};

export { InfoOutlineSvg };
